<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="产品类型">
        <el-select v-model="formInline.productType" placeholder="请选择">
          <el-option
            v-for="(item, index) in PRODUCT_TYPE_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="机器类型">
        <el-select
          v-model="formInline.machineType"
          placeholder="请选择"
          @change="handleChangeMachineType"
        >
          <el-option label="全部" :value="''"></el-option>
          <el-option
            v-for="(item, index) in $AllMachineModelInfoList"
            :key="index"
            :label="item.machineTypeCnName"
            :value="item.machineTypeCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机器型号">
        <el-select v-model="formInline.machineModel" placeholder="请选择">
          <el-option label="全部" :value="''"></el-option>
          <template v-if="formInline.machineType">
            <el-option
              v-for="(item, index) in $AllMachineModelInfoList.find(
                ele => ele.machineTypeCode === formInline.machineType
              ).machineSpec"
              :key="index"
              :label="item.machineModel + '【' + item.machineModelName + '】'"
              :value="item.machineModel"
            >
            </el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="产品名称">
        <el-input
          v-model="formInline.name"
          placeholder="请输入产品名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSearch"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column prop="productTemplateid" label="产品模板ID">
      </el-table-column> -->
      <el-table-column prop="productType" label="产品类型">
        <template slot-scope="scope">
          <div>
            {{ $getLabelByValue(scope.row.productType, PRODUCT_TYPE_ENUM) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="产品名称"> </el-table-column>

      <el-table-column prop="defaultPrice" label="价格(元)"> </el-table-column>
      <el-table-column label="机器类型">
        <template slot-scope="scope">
          <div>{{ scope.row.machineTypeCnName }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="machineCommand" label="机器指令">
      </el-table-column> -->
      <el-table-column prop="machineModel" label="机器型号"> </el-table-column>
      <!-- <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column> -->
      <el-table-column label="编辑时间">
        <template slot-scope="scope">
          <div>{{ scope.row.modifiedtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="handleEdit(scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    >
    </el-pagination>
    <DetailDialog
      v-if="isDialogShow"
      @closeForm="closeForm"
      @handleUpdate="onSearch"
      :isCreate="isCreate"
      :productInfo="productInfo"
      :machineModelList="machineModelList"
    />
  </div>
</template>

<script>
import enumObject from "../../plugins/enum";
import DetailDialog from "./components/detailDialog";
//import { mapGetters } from "vuex";
export default {
  components: {
    DetailDialog
  },
  data() {
    return {
      formInline: {
        productType: "",
        machineType: "",
        machineModel: "",
        name: "",
        machineCommand: ""
      },
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      isCreate: true,
      isDialogShow: false,
      productInfo: null,
      multipleSelection: [],
      PRODUCT_TYPE_ENUM: enumObject.PRODUCT_TYPE_ENUM,
      machineModelList: []
    };
  },

  methods: {
    handleChangeMachineType() {
      this.formInline.machineModel = "";
    },
    onSearch() {
      let queryModel = {
        productType: this.formInline.productType,
        machineType: this.formInline.machineType,
        machineModel: this.formInline.machineModel,
        name: this.formInline.name,
        machineCommand: this.formInline.machineCommand,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      if (this.formInline.machineModel == "全部") {
        queryModel.machineModel = null;
      }
      if (this.formInline.onlySearchOnline) {
        queryModel.isdisabled = false;
      }
      this.$axios(this.$urlMapping["查询产品模板"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSearch();
    },
    onAdd() {
      this.productInfo = null;
      this.isCreate = true;
      this.isDialogShow = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(productInfo) {
      this.productInfo = productInfo;
      this.isCreate = false;
      this.isDialogShow = true;
    },
    handleDelete(productInfo) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios(this.$urlMapping["删除产品模板"], {
          data: {
            templateids: Array.of(productInfo.productTemplateid)
          }
          // eslint-disable-next-line no-unused-vars
        }).then(() => {
          this.$notifySuccess();
          this.onSearch();
        });
      });
    },
    handleDisable(productid, disable) {
      let msg = disable ? "是否产品下线" : "是否产品上线";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let disableModel = {
          productIDs: [productid],
          disabled: disable
        };

        this.$axios(this.$urlMapping["产品上下线"], {
          data: disableModel
          // eslint-disable-next-line no-unused-vars
        }).then(() => {
          this.$notifySuccess();
          this.onSearch();
        });
      });
    },

    closeForm() {
      this.isDialogShow = false;
    },
    formatBoolean: function(row, column, cellValue) {
      var ret = ""; //你想在页面展示的值
      if (cellValue) {
        ret = "是"; //根据自己的需求设定
      } else {
        ret = "否";
      }
      return ret;
    }
  },
  async mounted() {
    this.onSearch();
    // await this.$axios(this.$urlMapping["查询机器联动"], {
    //   data: {}
    //   // eslint-disable-next-line no-unused-vars
    // }).then(result => {
    //   this.machineModelList = [
    //     { machineModel: "全部", machineName: "" },
    //     ...result
    //   ];
    // });
  }
};
</script>

<style lang="less" scoped></style>
